import { useEffect, useState } from "react";

// Satu lapisan CSS di belakang konten. Masuk sekali per sesi, lalu diam.
// Tidak mengulang saat pindah rute, ganti tab, atau scroll.
// Jika AppShell remount, keadaan masuk dijaga tanpa menambah layout.
let sessionAmbienceEntered = false;
try {
  if (typeof window !== "undefined" && window.sessionStorage?.getItem("ax_ambience_entered")) {
    sessionAmbienceEntered = true;
  }
} catch (_) {}

export const Ambience = () => {
  const [first] = useState(() => !sessionAmbienceEntered);

  useEffect(() => {
    sessionAmbienceEntered = true;
    try {
      window.sessionStorage?.setItem("ax_ambience_entered", "1");
    } catch (_) {}
  }, []);

  return <div aria-hidden="true" data-testid="ambience" className={`ax-ambience${first ? " ax-ambience-in" : ""}`} />;
};
